var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleFileAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18v4M8.5 14.5v11M13 9v22M17.5 15v10M22 11.5v17M26.5 16v8M31 13v14M35.5 18v4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleFileAudioIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_file_audio_icon.f0007cb3d1fcf21ccefcf42db5222aa0.svg";
export { ForwardRef as ReactComponent };